import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { loadExternalScript } from '@Shared/Common';
export var FacebookConnectSdk =
/*#__PURE__*/
function () {
  // https://developers.facebook.com/docs/facebook-login/web
  // https://developers.facebook.com/docs/javascript/reference/v10.0
  function FacebookConnectSdk() {
    _classCallCheck(this, FacebookConnectSdk);

    this.isInitialized = false;
  }

  _createClass(FacebookConnectSdk, [{
    key: "signIn",
    value: function signIn() {
      return this._loadSdk(function (resolve) {
        FB.login(function (response) {
          if (response && response.status === 'connected') {
            FB.api('/me', {
              fields: 'email'
            }, function (apiResponse) {
              resolve({
                accessToken: response.authResponse.accessToken,
                email: apiResponse.email
              });
            });
          } else {
            // if the user didn't successfully connect then we can ignore
            resolve();
          }
        }, {
          scope: 'email'
        });
      });
    }
  }, {
    key: "_loadSdk",
    value: function _loadSdk(onSuccess) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (_this.isInitialized) {
          onSuccess && onSuccess(resolve, reject);
        } else {
          var callbackWithInit = function callbackWithInit() {
            if (window.FB) {
              var appId = document.querySelector('meta[property="fb:app_id"]').getAttribute('content');
              FB.init({
                appId: appId,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v10.0'
              });
              _this.isInitialized = true;
              onSuccess && onSuccess(resolve, reject);
            } else {
              reject('Error loading Facebook SDK');
            }
          };

          var attributes = [{
            name: 'async',
            value: 'async'
          }];
          loadExternalScript('https://connect.facebook.net/en_US/sdk.js', 'facebookConnectSdk', callbackWithInit, attributes);
        }
      });
    }
  }]);

  return FacebookConnectSdk;
}();